import React, {useState} from 'react';
import Modal from '../../../Components/Modal';
import {usePredefined} from '../../../Data/Services';
import Icon from '../../../Components/Icons/Icon';
import Loading, { PageLoading } from '../../../Components/Loading';
import Accordion, { Panel } from '../../../Components/Containers/Accordion';
import Form, { TextField, Actions, Select, RequiredValidator} from '../../../Components/Form';
import { useDialogues } from '../../../Components/Dialogues';

const AddService = ({isOpen, setIsOpen, services, addService, isSaving, showEditInfo}) => {

    const [dismissible, setDismissible] = useState(true);
    const [addingType, setAddingType] = useState(null);
    const {predefined} = usePredefined();
    const {confirm} = useDialogues();

    const confirmAddService = async (e, type, title) => {
        e.preventDefault();
        e.stopPropagation();
        setDismissible(false);

        return confirm(
            {
                theme: 'primary',
                title: 'Add service',
                message: `Add ${title} service?`,
                onCancel: () => setDismissible(true),
            },
            async () => {
                setAddingType(type);
                await addService({type});
                setIsOpen(false);
            }
        )
    }

    return <Modal title="Add Service" isOpen={isOpen} setIsOpen={setIsOpen} dismissible={dismissible}>
        {predefined && <Inner {...{predefined, services, confirmAddService, addService, showEditInfo, isSaving, addingType}} />}
        {(predefined === null) && <PageLoading />}
    </Modal>
}

const Inner = ({predefined, services, confirmAddService, addService, showEditInfo, isSaving, addingType}) => {
    return <>
        <Accordion>
            {[
                ...predefined.map(category => {
                return <Panel key={category.category} title={category.category}>
                    <ul className="divide-y divide-gray-200">
                        {category.services.map(service => {
                            if (services && services.find(s => s.type === service.type)) {
                                return null;
                            }

                            return <li key={service.type} className="py-3 first:pt-2 last:pb-2">
                                <button className="w-full flex"
                                    onClick={(e) => confirmAddService(e, service.type, service.title)}
                                    disabled={isSaving}
                                >
                                    <div className="grow text-left">
                                        <p>{service.title}</p>
                                    </div>
                                    <div className="flex flex-none items-center gap-x-4 shrink-0">
                                        {service.type === addingType ?
                                            <Loading size="1x" inline /> :
                                            <Icon icon="Plus" className="mr-2" size="1x" inline />
                                        }
                                    </div>
                                </button>
                            </li>
                        })}
                    </ul>
                    <NoneToShow services={category.services} existing={services} />
                </Panel>
            }),
            <Panel title="Add your own" key="addCustomService">
                <AddCustomService categories={predefined.map(cat => cat.category)} addService={addService} />
            </Panel>
        ]}

        </Accordion>

        {showEditInfo && <p className="py-3 text-muted">
            You can change settings for each service in the More tab.
        </p>}
    </>
}

const NoneToShow = ({services, existing}) => {
    const category = services.map(s => s.type);
    const added = existing.map(s => s.type);

    const available = category.filter(c => !added.includes(c));

    if (available.length > 0) {
        return null;
    }

    return <p className="text-muted text-sm text-center m-5">
        You've added all the predefined service in this category.<br />
        Add your own using the Add your own tab.
    </p>
}

const AddCustomService = ({categories, addService}) => {
    return <Form data={{type: 'CUSTOM'}} onSubmit={addService} closeModalOnSubmit>
        <Select label="Service category"
            name="category"
            unselected="Select a category"
            options={categories.map(c => ({value: c, label: c}))}
            validators={[RequiredValidator]}
        />
        <TextField label="Service name"
            placeholder="Service name"
            name="title"
            validators={[RequiredValidator]}
        />
        <Actions submit={{label: 'Add'}} />
    </Form>
}

export default AddService;
